/* eslint-disable no-return-assign */
import { Modal as AModal, Image, Spin } from 'antd';
import React, { FC, Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { compose, Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled, { keyframes } from 'styles/styled-components';
import { ApplicationRootState } from 'types';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import SVGIcon from 'components/SVGIcon/SVGIcon';
import { Viewport } from 'components/ViewportProvider';
import { selectBuyer } from 'containers/MainLayout/selectors';
import { FormattedMessage } from 'react-intl';
import { Buyer } from 'types/schema';
import media from 'utils/mediaStyle';
import { EventName, sendGA4Event, triggerGA4SignUpEvent } from 'utils/triggerGA4Event';
import { ContactUsForm as IContactUsForm } from '../../ContactUsPage/types.d';
import { checkEmailSubmit, contactUsSubmit } from './actions';
import Benefits from './components/Benefits';
import ContactUs from './components/ContactUs';
import ContactUsForm from './components/ContactUsForm';
import OurCustomers from './components/OurCustomers';
import Partners, { SectionContainer, SectionTitle, SectionTitleBox } from './components/Partners';
import ProductsSource from './components/ProductsSource';
import WorkProcessCarousel from './components/WorkProcessCarousel';
import {
  arrowRightButton,
  arrowRightConsultationOddButton,
  closeIcon,
  herbsBackground,
  herbsCategory,
  herbsWidget,
  lettuceBackground,
  lettuceCategory,
  lettuceWidget,
  mushroomBackground,
  mushroomsCategory,
  mushroomWidget,
  scrollIndicator,
  sloganMainImage,
  sloganSubImage,
  vegetablesBackground,
  vegetablesCategory,
  vegetablesWidget,
  videoPlay,
} from './Images';
import messages from './messages';
import reducer from './reducer';
import saga from './saga';
import selectFarmToTablePage from './selectors';
import { ContainerState } from './types';
// import { FormattedMessage } from 'react-intl';
import useScrollPercentTracking from '../../../hooks/useScrollPercentTracking';
import Banner from './components/Banner';
import WhyChooseUsSection from './components/BenefitsCollapse';
import { MainButton } from './components/CommonComponents';
import ContactUsModal from './components/ContacUsModal';
import preloadImage from '../../../../public/images/preloadImage.png';

const Spinner = styled(Spin)`
  top: calc(100vh / 2) !important;
  transform: translateY(-50%) !important;
`;

const Container = styled.div`
  position: relative;
  margin-top: 100px;
  ${media.md`
  margin-top: 106px;
  }
  `}
`;

const VideoSection = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
  background: #ffffff;
  ${media.lg`
    height: calc(100vh - 106px);
    background: unset;
  `}
`;
const VideoWrapper = styled.div`
  position: relative;
  display: flex;
  height: 33vh;
  ${media.sm`
   height: 100%;
  }
  `}
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: linear-gradient(0deg, rgba(12, 12, 12, 0.3) 0%, rgba(12, 12, 12, 0.3) 100%);
  }
`;
const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative;
  pointer-events: none;
  &::-webkit-media-controls {
    display: none !important;
  }
`;

const VideoTextContainer = styled.div`
  width: 100%;
  padding: 0 16px;
  margin: 16px 0 0px;
  ${media.lg`
    position: absolute;
    padding: 0;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    z-index: 10;
    margin: 0 !important;
  `}
  @media()
  ${media.sm`
    margin: 16px 0 24px;
    `}
`;

const BlockContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  ${media.md`
    padding: 0 16px;
  `}
`;

const VideoTextTitle = styled.h1`
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  color: #000000;
  ${media.sm`
    font-size: 64px;
    font-weight: 700;
    line-height: 64px;
    color: #ffffff;
  `}
`;

const VideoSubText = styled.h3`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #000000;
  margin-top: 10px;
  ${media.md`
    font-size: 22px;
    font-weight: 500;
    line-height: 32px;
    color: #ffffff;
  `}
`;

const SloganDefineContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 20px 16px;
  ${media.xl`
      flex-direction: row;
      padding: 40px 0px 0px;
    `}
`;

const SloganDefineTextBox = styled.div`
  @media (max-width: 1199px) {
    margin-bottom: 125px;
  }
  @media (max-width: 991px) {
    margin-bottom: 59px;
  }
  transform: ${({ animate }) => (animate ? 'translateY(0px)' : 'translateY(100px)')};
  opacity: ${({ animate }) => (animate ? 1 : 0)};
  transition: all 1s ease;
  max-width: 525px;
`;

const SloganDefineText = styled.h3`
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  color: #242527;
  display: inline;
  ${({ highlight }) =>
    highlight &&
    `
    color: #3C9041;
  `}
  ${media.lg`
    font-size: 40px;
    line-height: 48px;
    `} // ${media.md`
  //   font-size: 30px;
  //   line-height: 38px;
  //   `}
`;

const SloganDefineSubTextWrapper = styled.div`
  margin-top: 8px;
  ${media.sm`
  margin-top: 16px;
  `}
`;

const SloganDefineSubText = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #242527;
  width: 100%;
  max-width: 532px;
`;

const SloganDefineImageWrapper = styled.div`
  position: relative;
  flex-grow: 1;
`;

const SloganDefineMainImageWrapper = styled.div`
  position: relative;
  left: -16px;
`;

const SloganDefineMainImage = styled.div`
  width: 50vw;
  height: calc(50vw * (472 / 362));
  background: url(${sloganMainImage});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 12px;
  position: relative
  margin: 0 auto;
  z-index: 10;
  ${media.xl`
    width: 362px;
    height: 472px;
    `}
  transform: ${({ animate }) => (animate ? 'translateY(0px)' : 'translateY(100px)')};
  opacity: ${({ animate }) => (animate ? 1 : 0)};
  transition: all 1s ease;
`;

const SloganDefineMainBackgroundImage = styled.div`
  background: rgba(111, 195, 115, 0.5);
  width: 50vw;
  height: calc(50vw * (436 / 358));
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 12px;
  position: absolute;
  z-index: 1;
  left: 50%;
  top: 50%;
  transform: translate(-40%, -62%);
  ${media.xl`
    width: 358px;
    height: 436px;
    `}
`;

const SloganDefineSubImage = styled.div`
  width: 18vw;
  height: calc(18vw * (181 / 155));
  background: url(${sloganSubImage});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 12px;
  position: absolute;
  top: 20%;
  right: unset;
  left: 100%;
  z-index: 10;
  ${media.xl`
    width: 155px;
    height: 181px;
    right: 0px;
    left: unset
    top: 100px;
    `}
  transform: ${({ animate }) => (animate ? 'translateX(0)' : 'translateX(100px)')};
  opacity: ${({ animate }) => (animate ? 1 : 0)};
  transition: all 1s ease;
`;

const scrollDown = keyframes`
  0% {
   transform: translateY(-20px);
  }
  100% {
    transform: translateY(0);
  }
`;

const ScrollIndicator = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
`;

const ScrollIndicatorImage = styled(SVGIcon)`
  animation: ${scrollDown} infinite alternate-reverse 0.8s;
`;

const PreloadImage = styled.img`
  width: 100%;
  left: 100%;
  object-fit: cover;
`;

const PlayVideo = styled.div`
  width: 100%;
  max-width: 1200px;
  position: absolute;
  bottom: 14px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  ${media.lg`
    bottom: 70px;
  `}
`;

const PlayVideoButton = styled.div`
  display: flex;
  align-item: center;
  gap: 8px;
  padding: 8px 12px;
  width: fit-content;
  border-radius: 32px;
  margin-left: 8px;
  ${media.lg`
    padding: 12px 16px;
  `}
  &:hover {
    background: rgba(255, 255, 255, 0.15) !important;
  }
  &:active {
    background: rgba(255, 255, 255, 0.07) !important;
  }
`;

const PlayVideoText = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  font-style: normal;
  color: #ffffff;
  cursor: pointer;
  ${media.md`
      font-size: 18px;
      line-height: 24px;
    `}
`;

const PreviewVideo = styled(Image)``;

const ClosePreviewVideo = styled(SVGIcon)`
  position: absolute;
  right: 0px;
  top: -40px;
  cursor: pointer;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 50%;
  &: hover {
    background: rgba(255, 255, 255, 0.15) !important;
  }
`;

const CategoryMobile = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 40px 16px 0;
  background: #ffffff;
  cursor: pointer;
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow: auto;
  ${media.sm`
    display: none;
  `}
`;

const CategoryMobileItem = styled.div`
  position: relative;
  height: 76px;
`;

const CategoryMobileImg = styled.img`
  width: 76px;
  height: 76px;
  object-fit: cover;
`;

const CategoryMobileText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  color: #ffffff;
  width: 100%;
  text-align: center;
`;

const ContactModal = styled(AModal)`
  & .ant-modal-content {
    padding: 10px !important;
  }
  & .ant-modal-close {
    border-radius: 50%;
    &: hover {
      background: #f6f6f6 !important;
    }
  }
`;

const ProductSourceWidget = styled.div`
  display: grid;
  grid-template-columns: 192px 192px;
  gap: 16px;
  margin-top: 16px;
`;

const ProductSourceWidgetItem = styled.div`
  border-radius: 8px;
  border: 1px solid #cacbce;
  padding: 16px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  height: 53px;
  &:before {
    content: '';
    position: absolute;
    bottom: -5px;
    right: 0px;
    padding-top: 30%;
    width: 70px;
    background: ${({ imageWidget }) => (imageWidget ? `url(${imageWidget})` : 'none')};
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    z-index: 2;
  }
  &:hover {
    ${({ sectionName }) =>
      sectionName === 'VEGETABLE_FARM' &&
      `
        background: #EFFFD6 !important;
        border-color: #94C747 !important;
    `}
    ${({ sectionName }) =>
      sectionName === 'LETTUCE_FARM' &&
      `
        background: #E7F9FF !important;
        border-color: #6CC3E0 !important;
    `}
    ${({ sectionName }) =>
      sectionName === 'HERBS_FARM' &&
      `
        background: #FFF7D6 !important;
        border-color: #E3B205 !important;
    `}
    ${({ sectionName }) =>
      sectionName === 'MUSHROOM_FARM' &&
      `
        background: #FFF3EB !important;
        border-color: #FEA363 !important;
    `}
  }
  &:active {
    ${({ sectionName }) =>
      sectionName === 'VEGETABLE_FARM' &&
      `
        background: #D3F1A7 !important;
    `}
    ${({ sectionName }) =>
      sectionName === 'LETTUCE_FARM' &&
      `
        background: #C6EDFB !important;
    `}
    ${({ sectionName }) =>
      sectionName === 'HERBS_FARM' &&
      `
        background: #F8E6A0 !important;
    `}
    ${({ sectionName }) =>
      sectionName === 'MUSHROOM_FARM' &&
      `
        background: #FEDEC8 !important;
    `}
  }
`;

const ProductSourceWidgetText = styled.span`
  font-weight: 500;
  color: #1d1e20;
`;

const ProductSourceWidgetImage = styled(SVGIcon)`
  position: absolute;
  right: -5px;
  bottom: 0;
  z-index: 1;
  cursor: pointer;
`;

const ConsultationButton = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: #3c9041;
  display: flex;
  align-item: center;
  gap: 6px;
  margin-top: 40px;
  width: fit-content;
  cursor: pointer;
  padding: 16px;
  border-radius: 80px;
  &:hover {
    background: #f0f9f1 !important;
  }
  &:active {
    background: #d4edd5 !important;
  }
`;

export interface IStateProps {
  farmToTable: ContainerState;
  buyer: Buyer;
}

interface IDispatchProps {
  onCheckEmail: (email: string) => void;
  onSubmit: (data: { values: IContactUsForm; cb: () => void }) => void;
}

type Props = IStateProps & IDispatchProps & RouteComponentProps;

const sectionImages = {
  VEGETABLE_FARM: vegetablesCategory,
  LETTUCE_FARM: lettuceCategory,
  HERBS_FARM: herbsCategory,
  MUSHROOM_FARM: mushroomsCategory,
};

const productWidgetImages = {
  VEGETABLE_FARM: vegetablesWidget,
  LETTUCE_FARM: lettuceWidget,
  HERBS_FARM: herbsWidget,
  MUSHROOM_FARM: mushroomWidget,
};

const productWidgetBackground = {
  VEGETABLE_FARM: vegetablesBackground,
  LETTUCE_FARM: lettuceBackground,
  HERBS_FARM: herbsBackground,
  MUSHROOM_FARM: mushroomBackground,
};

const FarmToTablePage: FC<Props> = (props) => {
  const {
    farmToTable: { isCheckingEmail, validationEmailMessage, submitting, sections },
    onCheckEmail,
    onSubmit,
    history,
    buyer,
  } = props;
  const lang = localStorage.getItem('lang') || 'vi';
  const loggedIn = !!localStorage.getItem('token');

  const [openContactModal, setOpenContactModal] = useState(false);
  const [isIntersecting, setIsIntersecting] = useState(false);
  const backgroundRef = useRef(null);
  const videoRef: any = useRef(null);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [isFormSuccess, setIsFormSuccess] = useState(false);
  const [isOpenContactModal, setIsOpenContactModal] = useState(false);
  const [openLargeVideo, setOpenLargeVideo] = useState(false);

  useScrollPercentTracking((scrollPercent) => {
    sendGA4Event(EventName.SCROLL_PERCENTAGE_FTB, {
      scroll_percentage_ftb: scrollPercent,
    });
  });

  const handlePlayClick = () => {
    setOpenLargeVideo(true);
    videoRef?.current?.pause();
    sendGA4Event(EventName.CLICK_WATCH_VIDEO_FTB);
  };

  const onSubmitContactUs = useCallback(
    (data: IContactUsForm) => {
      data.businessCategory = '';
      data.businessType = '';
      if (!data.email) {
        data.email = '';
      }
      onSubmit({
        values: data,
        cb: () => {
          setIsFormSuccess(true);
        },
      });
      triggerGA4SignUpEvent(data);
      if (window?.clarity) {
        window.clarity('set', 'sign_up', '1');
      }
    },
    [onSubmit],
  );

  const scrollToSection = (id, offset = 100) => {
    const element = document.getElementById(id);
    if (element) {
      const top = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ behavior: 'smooth', top: top });
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsIntersecting(true);
        }
      },
      {
        threshold: 0.5,
      },
    );

    if (backgroundRef.current) {
      observer.observe(backgroundRef.current);
    }

    return () => {
      if (backgroundRef.current) {
        observer.unobserve(backgroundRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const video: any = videoRef.current;
    const handleCanPlay = () => {
      setTimeout(() => {
        setIsVideoLoaded(true);
      }, 1000);
    };
    if (video) {
      video?.addEventListener('canplaythrough', handleCanPlay);
    }
    sendGA4Event(EventName.VIEW_FARM_TO_BIZ_PAGE_FTB);
    return () => {
      if (video) {
        video?.removeEventListener('canplaythrough', handleCanPlay);
      }
    };
  }, []);

  return (
    <Fragment>
      <Spinner spinning={false}>
        <Container>
          <VideoSection id="OUR_STORY">
            <VideoWrapper>
              {!isVideoLoaded && <PreloadImage src={preloadImage} alt="Poster" />}
              <VideoElement
                ref={videoRef}
                autoPlay
                muted
                defaultMuted
                src="https://image-handler-prod.s3.ap-southeast-1.amazonaws.com/supplier/654/PRODUCT_VIDEO/2025/6/Kamereo.mp4"
                loop
                controls={false}
                playsInline
                onContextMenu={(e) => e.preventDefault()}
                preload="auto"
              />
              <Viewport.Consumer>
                {({ width }) => {
                  return (
                    width < 1024 && (
                      <PlayVideo>
                        <PlayVideoButton>
                          <SVGIcon src={videoPlay} onClick={handlePlayClick} />
                          <PlayVideoText onClick={handlePlayClick}>
                            <FormattedMessage {...messages.playVideo} />
                          </PlayVideoText>
                        </PlayVideoButton>
                      </PlayVideo>
                    )
                  );
                }}
              </Viewport.Consumer>

              <Viewport.Consumer>
                {({ width }) => {
                  const isNotMobile = width > 1024;
                  return (
                    <PreviewVideo
                      id="preview_video"
                      preview={{
                        destroyOnClose: true,
                        visible: openLargeVideo,
                        imageRender: () => (
                          <div style={{ position: 'relative' }}>
                            <ClosePreviewVideo
                              src={closeIcon}
                              onClick={() => {
                                setOpenLargeVideo(false);
                                videoRef?.current?.play();
                              }}
                            />
                            <iframe
                              width={isNotMobile ? 1024 : width - 32}
                              height={isNotMobile ? 575 : 400}
                              src="https://www.youtube.com/embed/OC9FfwxMVAY?si=lm0r0_IMn8B0JdDT&autoplay=1&enablejsapi=1"
                              title="YouTube video player"
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                              referrerPolicy="strict-origin-when-cross-origin"
                              allowFullScreen
                            />
                          </div>
                        ),
                        onVisibleChange: (visible) => {
                          if (!visible) {
                            videoRef?.current?.play();
                            setOpenLargeVideo(visible);
                          }
                        },
                        toolbarRender: () => null,
                      }}
                      style={{ display: 'none' }}
                    />
                  );
                }}
              </Viewport.Consumer>
            </VideoWrapper>
            <Viewport.Consumer>
              {({ width }) => {
                return (
                  <VideoTextContainer>
                    <BlockContainer>
                      {width < 1024 ? (
                        <SectionTitleBox>
                          {lang === 'vi' ? (
                            <>
                              <SectionTitle highLight initial>
                                Từ nông trại đến doanh nghiệp,{' '}
                              </SectionTitle>
                              <SectionTitle initial>tươi ngon, ổn định mỗi ngày</SectionTitle>
                              <VideoSubText>
                                <FormattedMessage {...messages.pageSubText} values={{ break: <br /> }} />
                              </VideoSubText>
                            </>
                          ) : (
                            <>
                              <SectionTitle highLight initial flex>
                                From Farm to Business,{' '}
                              </SectionTitle>
                              <SectionTitle initial>Fresh, Reliable, Every Day</SectionTitle>
                              <VideoSubText>
                                <FormattedMessage {...messages.pageSubText} values={{ break: <br /> }} />
                              </VideoSubText>
                            </>
                          )}
                        </SectionTitleBox>
                      ) : (
                        <>
                          <VideoTextTitle>
                            <FormattedMessage {...messages.pageTitleText} values={{ break: <br /> }} />
                          </VideoTextTitle>
                          <VideoSubText>
                            <FormattedMessage {...messages.pageSubText} values={{ break: <br /> }} />
                          </VideoSubText>
                        </>
                      )}
                      <div style={{ marginTop: '20px' }}>
                        <MainButton
                          onClick={() => {
                            if (loggedIn) {
                              scrollToSection('PRODUCT_CATEGORY');
                              sendGA4Event(EventName.CLICK_FIND_SUPPLIER_FTB);
                            } else {
                              setOpenContactModal(true);
                              videoRef?.current?.pause();
                              sendGA4Event(EventName.START_SOURCING_FTB_CLICK);
                            }
                          }}
                          type="primary"
                          style={{ background: '#43A047' }}
                        >
                          {loggedIn ? (
                            <FormattedMessage {...messages.exploreVeggiesResource} />
                          ) : (
                            <FormattedMessage {...messages.registerNow} />
                          )}
                          <SVGIcon src={arrowRightButton} />
                        </MainButton>
                      </div>
                      {width > 1024 && (
                        <div style={{ marginTop: '20px', marginLeft: '-23px' }}>
                          <PlayVideoButton>
                            <SVGIcon src={videoPlay} onClick={handlePlayClick} />
                            <PlayVideoText onClick={handlePlayClick}>
                              <FormattedMessage {...messages.playVideo} />
                            </PlayVideoText>
                          </PlayVideoButton>
                        </div>
                      )}
                    </BlockContainer>
                  </VideoTextContainer>
                );
              }}
            </Viewport.Consumer>
            <Viewport.Consumer>
              {({ width }) => {
                const isNotMobile = width > 1024;
                return (
                  <>
                    {isNotMobile && (
                      <ScrollIndicator>
                        <ScrollIndicatorImage src={scrollIndicator} />
                      </ScrollIndicator>
                    )}
                  </>
                );
              }}
            </Viewport.Consumer>
          </VideoSection>
          <CategoryMobile>
            {Object.keys(sections).map((key) => (
              <CategoryMobileItem key={key} onClick={() => scrollToSection(key)}>
                <CategoryMobileImg src={sectionImages[key]} />
                <CategoryMobileText>
                  <FormattedMessage {...messages[key]} />
                </CategoryMobileText>
              </CategoryMobileItem>
            ))}
          </CategoryMobile>
          <Viewport.Consumer>
            {({ width }) => {
              const isMobile = width <= 576;
              return (
                <>
                  <SectionContainer>
                    <SloganDefineContainer>
                      <SloganDefineTextBox animate={isIntersecting}>
                        <SloganDefineText>
                          {lang === 'vi' ? (
                            <>
                              <SloganDefineText highlight>“Từ nông trại đến doanh nghiệp“</SloganDefineText>
                              {/* {!isMobile && <br />} */}
                              <SloganDefineText> là gì?</SloganDefineText>
                            </>
                          ) : (
                            <>
                              <SloganDefineText>What does </SloganDefineText>
                              <SloganDefineText highlight>
                                “From Farm to {!isMobile && <br />} Your Business”
                              </SloganDefineText>
                              <SloganDefineText> mean?</SloganDefineText>
                            </>
                          )}
                        </SloganDefineText>
                        <SloganDefineSubTextWrapper>
                          <SloganDefineSubText>
                            <FormattedMessage {...messages.sloganSubtext1} />
                          </SloganDefineSubText>
                        </SloganDefineSubTextWrapper>
                        {!loggedIn && width >= 1024 && (
                          <>
                            <ProductSourceWidget>
                              {Object.keys(sections).map((key) => (
                                <ProductSourceWidgetItem
                                  key={key}
                                  imageWidget={productWidgetImages[key]}
                                  onClick={() => scrollToSection(key)}
                                  sectionName={key}
                                >
                                  <ProductSourceWidgetText>
                                    {<FormattedMessage {...messages[key]} />}
                                  </ProductSourceWidgetText>
                                  <ProductSourceWidgetImage src={productWidgetBackground[key]} />
                                </ProductSourceWidgetItem>
                              ))}
                            </ProductSourceWidget>
                            <ConsultationButton
                              onClick={() => {
                                setIsOpenContactModal(true);
                                sendGA4Event(EventName.PRODUCT_CONSULT_FTB_CLICK);
                              }}
                            >
                              <FormattedMessage {...messages.getProductConsultation} />
                              <SVGIcon src={arrowRightConsultationOddButton} />
                            </ConsultationButton>
                            <ContactUsModal
                              isOpen={isOpenContactModal}
                              onCloseContactModal={() => setIsOpenContactModal(false)}
                            />
                          </>
                        )}
                      </SloganDefineTextBox>
                      <SloganDefineImageWrapper>
                        <SloganDefineMainImageWrapper>
                          <SloganDefineMainImage animate={isIntersecting} />
                          <SloganDefineMainBackgroundImage ref={backgroundRef} />
                        </SloganDefineMainImageWrapper>
                        <SloganDefineSubImage animate={isIntersecting} />
                      </SloganDefineImageWrapper>
                    </SloganDefineContainer>
                  </SectionContainer>
                  {loggedIn ? (
                    <>
                      <div id="PRODUCT_CATEGORY">
                        <ProductsSource />
                      </div>
                      <div id="PROCESS">
                        <WorkProcessCarousel />
                      </div>
                      <div id="BENEFITS">{width > 1200 ? <WhyChooseUsSection /> : <Benefits />}</div>
                      <div id="PARTNERS">
                        <OurCustomers />
                      </div>
                      <div id="GALLERY">
                        <Partners />
                      </div>
                      <Banner whiteBackground={true} openContactForm={() => setOpenContactModal(true)} />
                    </>
                  ) : (
                    <>
                      <div id="PROCESS">
                        <WorkProcessCarousel />
                      </div>
                      <div id="BENEFITS">{width > 1200 ? <WhyChooseUsSection /> : <Benefits />}</div>
                      <div id="PRODUCT_CATEGORY">
                        <ProductsSource />
                      </div>
                      <Banner openContactForm={() => setOpenContactModal(true)} />
                      <div id="PARTNERS">
                        <OurCustomers />
                      </div>
                      <div id="GALLERY">
                        <Partners />
                      </div>
                      <div id="CONTACT_US">
                        <ContactUs />
                      </div>
                    </>
                  )}
                </>
              );
            }}
          </Viewport.Consumer>
          <ContactModal
            maskClosable={true}
            closable={true}
            onCancel={() => {
              setOpenContactModal(false);
              setIsFormSuccess(false);
              videoRef?.current?.play();
            }}
            destroyOnClose={true}
            open={openContactModal}
            footer={null}
            centered
            width={650}
          >
            <ContactUsForm
              submitting={submitting}
              onSubmit={onSubmitContactUs}
              onCheckEmail={onCheckEmail}
              isCheckingEmail={isCheckingEmail}
              validationEmailMessage={validationEmailMessage}
              isSuccess={isFormSuccess}
            />
          </ContactModal>
        </Container>
      </Spinner>
    </Fragment>
  );
};

const mapStateToProps = createStructuredSelector<ApplicationRootState, IStateProps>({
  farmToTable: selectFarmToTablePage(),
  buyer: selectBuyer(),
});

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  onSubmit: (data: { values: IContactUsForm; cb: () => void }) => dispatch(contactUsSubmit(data)),
  onCheckEmail: (email: string) => dispatch(checkEmailSubmit(email)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withReducer = injectReducer({
  key: 'farmToTablePage',
  reducer: reducer,
});

const withSaga = injectSaga({ key: 'farmToTablePage', saga: saga });

export default compose(withConnect, withReducer, withSaga)(FarmToTablePage);
